import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { Route, IndexRedirect } from '@americanexpress/one-app-router';
import { BASE_UI_URL } from '@americanexpress/arcade-core';
import ErrorPage from './components/ErrorPage';

const childRoutes = () => [
  <Route key="redirect" path="/">
    <IndexRedirect to={`${BASE_UI_URL}`} />
  </Route>,
  <ModuleRoute key="tcm-routes" path=":locale/web3">
    <IndexRedirect to={`${BASE_UI_URL}`} />
    <ModuleRoute path="passport" moduleName="arcade-page-wrapper">
      <ModuleRoute path="landing" moduleName="arcade-landing" />
      <ModuleRoute path="enroll" moduleName="arcade-enroll" />
      <ModuleRoute path="explore" moduleName="arcade-explore" />
      <ModuleRoute path="stamps" moduleName="arcade-stamps-overview" />
      <ModuleRoute path="wishlist" moduleName="arcade-explore" />
      <ModuleRoute path="more" moduleName="arcade-settings" />
    </ModuleRoute>
  </ModuleRoute>,
  <Route key="404" path="*" component={ErrorPage} />,
];

export default childRoutes;
